import { createFileRoute, Link } from "@tanstack/react-router";
import { ShieldAlert } from "lucide-react";

export const Route = createFileRoute("/dashboard/doctor_/archived")({
  component: ArchivedNotice,
});

function ArchivedNotice() {
  return (
    <div className="min-h-full flex items-center justify-center p-8">
      <div className="max-w-md text-center space-y-4">
        <ShieldAlert className="h-10 w-10 mx-auto text-red-600" />
        <h1 className="text-xl font-semibold">Your listing has been archived</h1>
        <p className="text-sm text-muted-foreground">
          Your dashboard access has been suspended. If you believe this is a mistake, contact
          our support team.
        </p>
        <Link to="/" className="text-sm underline">Return to home</Link>
      </div>
    </div>
  );
}
